// TODO: Move register etc. stuff.
import { GeoRBush } from "./mm/geo/GeoRBush";
import { Graph } from "./mm/graph/Graph";
import * as mm from "./mm/index";
import * as infra3d from "./infra3d/index";
import { Viewer } from "./mm/viewer/Viewer";
Graph.register(GeoRBush);
import { ComponentService } from "./mm/component/ComponentService";
import { DirectionComponent } from "./mm/component/direction/DirectionComponent";
import { SequenceComponent } from "./mm/component/sequence/SequenceComponent";
import { KeyboardComponent } from "./mm/component/keyboard/KeyboardComponent";
import { MapComponent } from "./mm/component/map/MapComponent";
import { AxisscaleBarComponent } from "./mm/component/axisscalebar/AxisscaleBarComponent";
ComponentService.register(DirectionComponent);
ComponentService.register(SequenceComponent);
ComponentService.register(KeyboardComponent);
ComponentService.register(MapComponent);
ComponentService.register(AxisscaleBarComponent);
export { mm, infra3d, Viewer };
//# sourceMappingURL=index.js.map